export const fontFamilies = {
  heading:
    '"Inter", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  body: '"Inter", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  mono: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
} as const;

export const typeScale = { xs: 10, sm: 12, md: 14, lg: 16, xl: 20, '2xl': 28, '3xl': 32 } as const;

export const typography = {
  pageTitle: {
    fontFamily: fontFamilies.heading,
    fontSize: 28,
    lineHeight: 1.2,
    fontWeight: 600,
    letterSpacing: '-0.01em',
  },
  sectionTitle: {
    fontFamily: fontFamilies.heading,
    fontSize: 16,
    lineHeight: 1.375,
    fontWeight: 600,
    letterSpacing: '-0.005em',
  },
  body: { fontFamily: fontFamilies.body, fontSize: 14, lineHeight: 1.45, fontWeight: 400 },
  bodyMuted: {
    fontFamily: fontFamilies.body,
    fontSize: 14,
    lineHeight: 1.45,
    fontWeight: 400,
  },
  label: {
    fontFamily: fontFamilies.body,
    fontSize: typeScale.sm,
    lineHeight: 1.4,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  labelTitle: {
    fontFamily: fontFamilies.body,
    fontSize: typeScale.sm,
    lineHeight: 1.4,
    fontWeight: 600,
    letterSpacing: 0,
    textTransform: 'none',
  },
  caption: {
    fontFamily: fontFamilies.body,
    fontSize: typeScale.sm,
    lineHeight: 1.4,
    fontWeight: 500,
    letterSpacing: 0,
  },
  mono: { fontFamily: fontFamilies.mono, fontSize: typeScale.sm, lineHeight: 1.5, fontWeight: 500 },
} as const;
